<!--
 * @Author: tfq
 * @Date: 2025-12-19 13:26:21
 * @LastEditTime: 2026-01-22 09:20:55
 * @Description: 
-->
<template>
  <video v-if="!isIOS && url" :width="width" :height="height" class="video-inner" controls playsinline
    webkit-playsinline x5-playsinline preload="auto">
    <source :src="url" type="video/mp4" />
  </video>
  <div v-else-if="url" class="video-box" :style="{ height: height, width: width }">
    <div v-if="showPlayBtn" class="play-btn-container" @click="playVideo">
      <img v-if="coverUrl" :src="coverUrl" class="poster">
      <img v-else :src="poster" class="poster">
      <img :src="require('../../assets/play-btn.png')" class="play-btn">
    </div>
    <canvas ref="canvasRef" style="display: none;"></canvas>
    <video v-show="!showPlayBtn" :width="width" :height="height" :id="keyRandom" class="video-inner" controls
      playsinline webkit-playsinline x5-playsinline preload="auto">
      <source :src="url" type="video/mp4" />
    </video>
    <!-- 作用获取视频元数据 -->
    <video ref="videoRef" class="video-hidden" :src="url" :width="width" :id="`hide-${keyRandom}`"
      @loadedmetadata="handleLoadedMetadata" @seeked="captureFrame" crossOrigin="anonymous" preload="auto" muted
      playsinline webkit-playsinline x5-playsinline>
    </video>
  </div>
</template>

<script>

export default {
  props: {
    url: '',
    // ios严格禁止自动播放视频
    // type: { 
    //   type: String,
    //   default: 'autoplay',
    // },
    poster: String,
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '100%',
    },
  },
  data() {
    return {
      showPlayBtn: true,
      keyRandom: Math.random() * 1000,
      coverUrl: '',
      // 是否是ios系统
      isIOS: true,
      // isIOS: /iPad|iPhone|iPod/.test(navigator.userAgent),
    };
  },
  created() {
  },

  mounted() {
    // const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

    // if (this.type === 'autoplay') {
    //   if (isIOS) {
    //     video.muted = true;
    //     video.playsInline = true;
    //     // 尝试自动播放
    //     video.play().catch(() => {
    //       // 显示自定义播放控件
    //     });
    //   } else {
    //     video.autoplay = true;
    //   }
    // }
    const video = document.getElementById(this.keyRandom);
    const videoView = document.getElementById(`hide-${this.keyRandom}`);
    console.log('video-mounted');
    if (video) {
      video.addEventListener('play', () => {
        this.showPlayBtn = false;
        console.log('playVideo', this.showPlayBtn, this.isIOS);
      });
    }

    if (videoView) {
      console.log('video-addEventListener');
      videoView.muted = true; // 确保静音

      const tryPlay = () => {
        if (this.coverUrl) return; // 已有封面不再尝试
        videoView.play().then(() => {
          setTimeout(() => {
            videoView.pause();
          }, 50);
        }).catch(e => {
          console.log('auto play fail', e);
        });
      };

      // 1. 立即尝试
      tryPlay();

      // 2. 微信环境尝试
      if (typeof window.WeixinJSBridge === 'object' && typeof window.WeixinJSBridge.invoke === 'function') {
        tryPlay();
      } else {
        document.addEventListener("WeixinJSBridgeReady", tryPlay, { once: true });
      }

      // 3. 用户交互兜底 (最稳妥的方式)
      const interactionHandler = () => {
        tryPlay();
        document.removeEventListener('touchstart', interactionHandler);
        document.removeEventListener('click', interactionHandler);
      };
      document.addEventListener('touchstart', interactionHandler, { once: true });
      document.addEventListener('click', interactionHandler, { once: true });
    }
  },
  destroyed() {
    // 事件监听已移至模板中，无需手动移除
  },

  methods: {
    handleLoadedMetadata() {
      console.log('video-loadedmetadata');
      const video = document.getElementById(`hide-${this.keyRandom}`);
      // 检查video是否存在以及currentTime是否有效
      if (video && video.duration && isFinite(video.duration)) {
        video.currentTime = 0.1;
      }
    },
    // 截取视频第一帧作为封面
    captureFrame() {
      console.log('video-captureFrame-start');
      try {
        const video = document.getElementById(`hide-${this.keyRandom}`);
        const canvas = this.$refs.canvasRef;
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        this.coverUrl = canvas.toDataURL('image/jpeg');
        console.log('video-captureFrame', Boolean(this.coverUrl));
      } catch (e) {
        console.log('video-captureFrame-error', e);
      }
    },
    playVideo() {
      const video = document.getElementById(this.keyRandom);
      this.showPlayBtn = false;
      video.play().catch(() => {
        this.showPlayBtn = true; // 播放失败时恢复显示
      });
      console.log('playVideo', this.showPlayBtn, this.isIOS);
    },

  },
};
</script>

<style lang="less" scoped>
// .play-btn,
// .poster {
//   position: absolute;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   pointer-events: none;
//   /* 允许点击穿透到视频 */
// }

.play-btn-container {
  width: 100%;
  height: 100%;
}

.poster {
  width: 100%;
  height: 100%;
  object-fit: contain;
  filter: contrast(0.5);
}

.play-btn {
  position: absolute;
  width: 64px;
  height: 64px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.video-box {
  margin-bottom: 10px;
  position: relative;
  z-index: 1;
}

.video-hidden {
  position: absolute;
  top: 0;
  left: 0;
  width: 1px;
  height: 1px;
  opacity: 0.01;
  pointer-events: none;
  z-index: -1;
}
</style>
